import { Component, OnInit, Inject } from '@angular/core';
import { _ } from '@icc/shared/helpers';
import { PageComponent, SharedFacade, ICC_PAGE_DATA, ModalService } from '@icc/configurator/shared';
import { iccListItem, iccListTab } from '@icc/configurator/ui';
import { TranslateService } from '@icc/shared';
import { IccAccessoryAccessory } from '@icc/construction-elements/types';
import { ConstructColorDto as IccConstructColor } from '@icc/construction-elements/types';
import { ActiveSash } from '@icc/window-door/types';
import { SillOptionsPageComponent } from '../sill-options-page/sill-options-page.component';

@Component({
    selector: 'icc-sills-list-page',
    templateUrl: './sills-list-page.component.html',
    styleUrls: ['./sills-list-page.component.scss'],
    standalone: false
})
export class SillsListPageComponent extends PageComponent implements OnInit {
  public title = this.translateService.instant('WINDOWSILL|Parapety');
  public options = [];

  accessories: iccListItem[] = [];
  tabs: iccListTab[] = [
      {
          id: 'w',
          name: this.translateService.instant('WINDOWSILL|Wewnętrzny')
      },
      {
        id: 'z',
        name: this.translateService.instant('WINDOWSILL|Zewnętrzny')
    },
    {
        id: 'wz',
        name: this.translateService.instant('WINDOWSILL|Wewnętrzny / zewnętrzny')
    }
  ]

  constructor(
      private sharedFacade: SharedFacade,
      private modalService: ModalService,
      private translateService: TranslateService,
      @Inject(ICC_PAGE_DATA)
      private pageData: {
          sills: any[];
          categories: any[];
          colors?: IccConstructColor[];
          noPrice: boolean;
      }
  ) {
      super();
  }

  ngOnInit() {
      this.accessories = this.pageData.sills.map<iccListItem>(accessory => ({
          id: Number(accessory.id),
          title: accessory.name,
          imageUrl: `/files/windowsill/${accessory.image}`,
          description: `${accessory.description}`,
          tabs: [accessory.type]
      }));
  }

  selectAccessory(item: iccListItem) {
      const accessory = this.pageData.sills.find(a => Number(a.id) === Number(item.id));
      if (accessory) {
          this.modalService
              .open({
                  pageComponent: SillOptionsPageComponent,
                  resolve: {
                      accessory,
                      colors: this.pageData.colors,
                  },
              })
              .result.then(result => {
                  this.sharedFacade.closePage(result);
              });
      }
  }

}
